module.exports = __webpack_public_path__ + "static/media/minus.755ea387.png";